<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LxS3bQ/tc-custom/9781497658080.jpg?1701061018859" alt="This image is the cover for the book Refugee, Bio of a Space Tyrant"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Refugee, Bio of a Space Tyrant
      </h1>
      <p class="bookDescription body article font2">
        <b>The future tyrant begins his path to power as an asylum seeker on Jupiter in this sci-fi series opener from the <i>New York Times</i>–bestselling author.</b><br/><br/> Though he was later accused of every crime and sexual perversion in the galaxy, Hope Hubris began as an innocent. Because he defended his older sister against the violent lusts of a wealthy scion, Hope and his peasant family were forced to flee Callisto, one of the moons of Jupiter. Pursued by the bloodthirsty scions across the airless desert, they barely escaped with their lives. The illegal space bubble was overcrowded with refugees, all hoping to reach Jupiter for asylum.<br/><br/> But the space travelers had not reckoned on the terrible threat of high space—the pirates, barbaric men who rape, rob, and murder, with no thought but to satisfy their bestial appetites. It will take all Hope’s ingenuity to survive, but the atrocities he witnesses will never die. There is only one way he can be rid of them . . .<br/><br/> Revenge.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Piers Anthony
      </h2>
      
      <p class="authorDescription body article"> Piers Anthony is one of the world&rsquo;s most popular fantasy writers, and a&#160;<I>New York Times</I>&ndash;bestselling author twenty-one times over. His Xanth novels have been read and loved by millions of readers around the world, and he daily receives letters from his devoted fans. In addition to the Xanth series, Anthony is the author of many other bestselling works. He lives in Inverness, Florida. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Premier Digital Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?071ae474